export const actionGetFoodPackageDetails = (details) => ({
    type: 'SET_FOOD_PACKAGE_DETAILS', details
})


export const actionChangeFoodPackageProductCheck = (productGradeId, isBasic, isCheck) => ({
    type: 'CHANGE_FOOF_PACKAGE_PRODUCT_CHECK', productGradeId, isBasic, isCheck
})

export const actionChangeInputNumberProductInFoodPackage = (productGradeId, isBasic, direction) => ({
    type: 'CHANGE_INPUT_NUMBER_PRODUCT_IN_FOOD_PACKAGE', productGradeId, isBasic, direction
});


export const actionChangeNumOfCheckedProducts = (num) => ({
    type: 'SET_NUM_OF_CHECKED_PRODUCTS', num
});

export const actionChangeFirstNumOfCheckedProducts = (num) => ({
    type: 'SET_FIRST_NUM_OF_CHECKED_PRODUCTS', num
});

export const actionSetFoodPackChangedByUser = (status) => ({
    type: 'SET_FOOD_PACK_CHANGEd_BY_USER', status
});